// extracted by mini-css-extract-plugin
module.exports = {"label":"InputLabel_label__fuYA-","labelWrapper":"InputLabel_labelWrapper__2UiXr","history-indication":"InputLabel_history-indication__2G4XW"};